import servise from '@/router/axios'

// 查询列表
export const fetchDistOppoAppConfig = (params) => {
  return servise({
    url: '/distOppoAppConfig/occupy',
    method: 'get',
    params
  })
}

// 修改应用配置
export const updateDistOppoAppConfig = (data) => {
  return servise({
    url: '/distOppoAppConfig/config',
    method: 'PUT',
    data
  })
}